export abstract class BaseEntity {
  id?: string = '00000000-0000-0000-0000-000000000000';
  numericId?: number = null; // Id ACEP
  createdBy: string = null;
  createdOnUtc: Date = new Date();
  lastModifiedBy: string = null;
  lastModifiedOnUtc?: Date = null;
  isCommon: boolean = true;
  isActive: boolean = true;
  isDeleted: boolean = false;
}
